/**************************************************
 * Nombre:       Dialogo_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Check, Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Deposito from "../Formularios/Formulario_Deposito";
import {useContext} from "react";
import {usuarioContext} from "../../App";

const Dialogo_Deposito = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Guardando datos')

        let dox = await guardarDoc('movimientos', entidad)
        if (dox.res) {

            terminar({aviso: 'Deposito creado, descarga recibo de pago'})
        } else {
            terminar({aviso: 'Ups algo inesperado paso, intentalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('movimientos', datos.id)
        terminar({aviso: 'deposito borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Deposito props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<Check/>}
                >Actualizar Deposito</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', marginTop: 3}}>
                <Button
                    variant={'text'}
                    color={'success'}
                    onClick={() => borrar()}
                    startIcon={<Delete/>}
                >Borrar Movimiento</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Deposito